module.exports = __webpack_public_path__ + "static/the-money-cloud-banner-99742f917b046227624bb107d23eef35.png";